import type { Panel } from './app';

export const env = {
  stage: (import.meta.env.VITE_STAGE || 'prd') as 'dev' | 'prd',
  isLocal: import.meta.env.VITE_IS_LOCAL || null,

  version: import.meta.env.VITE_VERSION || '1',

  apiUrl: import.meta.env.VITE_API_URL,
  apiClientId: import.meta.env.VITE_API_CLIENT_ID,

  authUrl: import.meta.env.VITE_AUTH_URL,

  appId: import.meta.env.VITE_APP_ID as Panel,

  supportUrl: import.meta.env.VITE_SUPPORT_URL,

  mailUrl: import.meta.env.VITE_MAIN_URL,

  captchaKey: import.meta.env.VITE_CAPTCHA_KEY,
};
